import { render } from "./AppPrayerCircles.vue?vue&type=template&id=5e18f1c8"
import script from "./AppPrayerCircles.vue?vue&type=script&lang=js"
export * from "./AppPrayerCircles.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__